export default __webpack_public_path__ + "static/media/best.10bb5230.png";